/**
 * Canonical public URL helpers for Figgy business pages.
 *
 * Single source of truth: getfiggy.link/{slug} is the canonical client link.
 * All URL generators in the frontend should import from here.
 *
 * In development (import.meta.env.DEV), getPublicUrl uses window.location.origin
 * so that "View page" and "Copy link" actions open the local dev server instead
 * of production. This keeps local QA honest — you test what is actually running.
 *
 * Production behavior is unchanged: https://getfiggy.link/{slug}.
 */

const PROD_BASE = 'https://getfiggy.link';

/**
 * Full absolute URL for the public business page.
 * - Production: https://getfiggy.link/{slug}
 * - Development: http://localhost:5173/{slug} (or whatever origin is active)
 */
export function getPublicUrl(slug: string): string {
  if (import.meta.env.DEV) {
    return `${window.location.origin}/${slug}`;
  }
  return `${PROD_BASE}/${slug}`;
}

/**
 * The canonical production URL, always getfiggy.link/{slug}.
 * Use for display copy only (shown to the user as their shareable link),
 * never for navigation.
 */
export function getCanonicalDisplayUrl(slug: string): string {
  return `${PROD_BASE}/${slug}`;
}

/** Root-relative path for React Router navigation: /{slug} */
export function getPublicPath(slug: string): string {
  return `/${slug}`;
}
